class ProductForm extends HTMLElement {
  constructor() {
    super();
    this.form = this.querySelector('form.product-form');
    this.sectionId = this.form?.dataset.sectionId;
    this.submitButton = this.form?.querySelector('button[type="submit"]');
    this.sizeChartActivator = this.querySelector('[data-size-modal]');
    if(this.submitButton) this.form?.dispatchEvent(new Event('submit'));
  }

  connectedCallback() {
    this.form?.addEventListener('submit', this.onSubmitHandler.bind(this));
    this.sizeChartActivator?.addEventListener('click', (e) => {
      this.sizeChartActivator?.closest('#quickViewModal')?.querySelector('#sizeChartModal')?.show();
    })
  }
  
  getSectionsToRender() {
    return [
      {
        id: 'main-cart-items',
        section: document.getElementById('main-cart-items')?.dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-icon-bubble',
        section: 'cart-icon-bubble',
        selector: '.shopify-section',
      },
      {
        id: 'main-cart-footer',
        section: document.getElementById('main-cart-footer')?.dataset.id,
        selector: '.js-contents',
      },
      {
        id: 'cart-drawer',
        section: 'cart-drawer',
        selector: '.cart-drawer-index',
      },
    ];
  }

  getSectionInnerHTML(html, selector) {
    if(!html) return;
    return new DOMParser().parseFromString(html, 'text/html').querySelector(selector)?.innerHTML;
  }

  onSubmitHandler = (e) => {
    e.preventDefault();

    if(__st.p == 'product') {
      let variantOptions = this.closest('.pdp-content-wrapper').querySelectorAll('variant-selector .option-variant-wrapper');
      let allOptionSelected = true;
      variantOptions.forEach(variantOpt => {
        let selectedOpt = variantOpt.querySelector('input:checked');
        if (!selectedOpt) {
          allOptionSelected = false;
          let errorElement = variantOpt.querySelector('.error-message');
          errorElement.classList.remove('d-none');
          
          const elementPosition = errorElement.getBoundingClientRect().top + window.scrollY;
          window.scrollTo({
            top: elementPosition - 200,
            behavior: 'smooth'
          });
          
          setTimeout(() => {
            errorElement.classList.add('d-none');
          }, 6000);
        }
      });
      if (allOptionSelected == false) {
        return false;  
      } 
    }

    // Assuming Utility is an object that looks like this:
const Utility = {
  serializeForm: function(formElement) {
    const formData = new FormData(formElement);
    const formObject = {};
    formData.forEach((value, key) => {
      formObject[key] = value;
    });
    return JSON.stringify(formObject); // or any other format you need
  }
};

    
    const addItems = [];
    const submitButton = this.querySelector('[type="submit"]');
    const qtyInput = this.querySelector('[data-qty-input]');

    submitButton.setAttribute('disabled', true);
    submitButton.classList.add('loading');

    addItems.push(JSON.parse(Utility.serializeForm(this.form)));
    const body = JSON.stringify({
      items: addItems,
      sections: this.getSectionsToRender().map((section) => section.section),
    });
    
    fetch(`${routes.cart_add_url}`, { ...fetchConfig(), ...{ body } })
    .then((response) => response.json())
    .then((parsedState) => {
      
      this.getSectionsToRender().forEach((section) => {
        if (section.section != "" && section.section != undefined) {
          const elementToReplace = document.getElementById(section.id)?.querySelector(section.selector) || document.getElementById(section.id);
          if (elementToReplace) {
            elementToReplace.innerHTML = this.getSectionInnerHTML(
              parsedState.sections[section.section],
              section.selector
            );  
          }
        }
      });

      // close sizechart model of sticky atc
      document.querySelector("#sizeChartModal")?.hide();
      document.querySelectorAll('sizechart-table [ḍata-sizechart-atc]')?.forEach(btn => btn.removeAttribute('disabled'));
      document.querySelectorAll('floating-atc [data-trigger-float-atc]')?.forEach(btn => btn.removeAttribute('disabled'));

      // hide quickview model
      this.closest('#quickViewModal')?.hide();

      // open cart drawer
      document.querySelector('ajax-cart')?.classList.remove('is-empty');
      document.body.classList.add('cart-drawer-open');
      document.querySelector('site-overlay').showOverlay();
      
      // Update lozad observer for newly loaded images in cart
      if (typeof window.updateLozad === 'function') {
        window.updateLozad();
      }
    }).catch((e) => {
      console.log(e);
    })
    .finally(() => {
      submitButton.removeAttribute('disabled');
    });

  }
}
customElements.define('product-form', ProductForm);



  /**
   * Defer media like extenral videos and internal videos of liquid object and play it when clicked on play button
   */
  class DeferredMedia extends HTMLElement {
    constructor() {
      super();
      const poster = this.querySelector('data-trigger-video');
      if (!poster) return;
      poster.addEventListener('click', this.loadContent.bind(this));
    }
  
    loadContent(focus = true) {
      this.pauseAllMedia();
      if (!this.getAttribute('loaded')) {
        const content = document.createElement('div');
        content.appendChild(this.querySelector('template').content.firstElementChild.cloneNode(true));
  
        this.setAttribute('loaded', true);
        const deferredElement = this.appendChild(content.querySelector('video, model-viewer, iframe'));
        if (focus) deferredElement.focus();
        if (deferredElement.nodeName == 'VIDEO' && deferredElement.getAttribute('autoplay')) {
          // force autoplay for safari
          deferredElement.play();
        }
      }
    }
  
    pauseAllMedia() {
      document.querySelectorAll('.js-youtube').forEach((video) => {
        video.contentWindow.postMessage('{"event":"command","func":"' + 'pauseVideo' + '","args":""}', '*');
      });
      document.querySelectorAll('.js-vimeo').forEach((video) => {
        video.contentWindow.postMessage('{"method":"pause"}', '*');
      });
      document.querySelectorAll('video').forEach((video) => video.pause());
      document.querySelectorAll('product-model').forEach((model) => {
        if (model.modelViewerUI) model.modelViewerUI.pause();
      });
    }
  }
  
  customElements.define('deferred-media', DeferredMedia);